module.exports = __webpack_public_path__ + "img/three_phase.d6627e93.png";